up.migrate.clearCacheFromXHR = function (xhr) {
    let value = xhr.getResponseHeader('X-Up-Clear-Cache');
    if (value) {
        up.migrate.deprecated('X-Up-Clear-Cache', 'X-Up-Expire-Cache');
        if (value === 'false') {
            return false;
        }
        else {
            return value;
        }
    }
};
up.migrate.titleFromXHR = function (xhr) {
    let value = xhr.getResponseHeader('X-Up-Title');
    if (value) {
        if (value === 'false') {
            return false;
        }
        else if (value[0] !== '"' && value[0] !== "'") {
            up.migrate.warn('X-Up-Title must now be a JSON-encoded string');
            return value;
        }
    }
};
up.protocol.config.patch(function () {
    const cspNonceMoved = () => up.migrate.deprecated('up.protocol.config.cspNonce', 'up.script.config.cspNonce');
    Object.defineProperty(this, 'cspNonce', {
        configurable: true,
        get() {
            cspNonceMoved();
            return up.script.config.cspNonce;
        },
        set(value) {
            cspNonceMoved();
            up.script.config.cspNonce = value;
        }
    });
});
